import Vue from 'vue';
import {
    ADMIN_ADD_RESULTTAG_ERROR,
    ADMIN_ADD_RESULTTAG_REQUEST,
    ADMIN_ADD_RESULTTAG_SUCCESS,
    ADMIN_DELETE_RESULTTAG_ERROR,
    ADMIN_DELETE_RESULTTAG_REQUEST,
    ADMIN_DELETE_RESULTTAG_SUCCESS, ADMIN_RESULTSURVEY_ERROR,
    ADMIN_RESULTSURVEY_REQUEST, ADMIN_RESULTSURVEY_SUCCESS,
    ADMIN_RESULTTAG_ERROR,
    ADMIN_RESULTTAG_REQUEST,
    ADMIN_RESULTTAG_SUCCESS,
    ADMIN_RESULTTAGS_ERROR,
    ADMIN_RESULTTAGS_REQUEST,
    ADMIN_RESULTTAGS_SUCCESS,
    ADMIN_UPDATE_RESULTTAG_ERROR,
    ADMIN_UPDATE_RESULTTAG_REQUEST,
    ADMIN_UPDATE_RESULTTAG_SUCCESS, GET_REPORT_SURVEY_ERROR, GET_REPORT_SURVEY_REQUEST, GET_REPORT_SURVEY_SUCCESS,
    GET_RESULT_ERROR, GET_RESULT_REQUEST, GET_RESULT_SUCCESS
} from './actiontypes'
import adminApi from '../../../_services/api/result';

const state = {
    reports: [],
    report: {},
    results: [],
    tags: [],
    tag: {},
    question: {},
    status: '',
    errors: [],
    hasLoadedOnce: false,
};

const getters = {
    getResultTags: state => state.tags,
};

const actions = {
    [GET_RESULT_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_RESULT_REQUEST);
            adminApi.getReport(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_RESULT_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(GET_RESULT_ERROR , response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_RESULT_ERROR, error);
                    reject(error);
                });
        });
    },
    [GET_REPORT_SURVEY_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(GET_REPORT_SURVEY_REQUEST);
            adminApi.getReports()
                .then((response) => {
                    if (response.success === true) {
                        commit(GET_REPORT_SURVEY_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(GET_REPORT_SURVEY_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(GET_REPORT_SURVEY_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_RESULTSURVEY_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_RESULTSURVEY_REQUEST);
            adminApi.getResults()
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_RESULTSURVEY_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_RESULTSURVEY_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_RESULTSURVEY_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_RESULTTAGS_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_RESULTTAGS_REQUEST);
            adminApi.getTags(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_RESULTTAGS_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_RESULTTAGS_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_RESULTTAGS_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_RESULTTAG_REQUEST]: ({ commit, dispatch }, tag_id) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_RESULTTAG_REQUEST);
            adminApi.getTag(tag_id)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_RESULTTAG_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_RESULTTAG_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_RESULTTAG_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_ADD_RESULTTAG_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_ADD_RESULTTAG_REQUEST);
            adminApi.addTag(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_ADD_RESULTTAG_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_ADD_RESULTTAG_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_ADD_RESULTTAG_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_UPDATE_RESULTTAG_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_UPDATE_RESULTTAG_REQUEST);
            adminApi.updateTag(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_UPDATE_RESULTTAG_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_UPDATE_RESULTTAG_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_UPDATE_RESULTTAG_ERROR, error);
                    reject(error);
                });
        });
    },
    [ADMIN_DELETE_RESULTTAG_REQUEST]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(ADMIN_DELETE_RESULTTAG_REQUEST);
            adminApi.deleteTag(payload)
                .then((response) => {
                    if (response.success === true) {
                        commit(ADMIN_DELETE_RESULTTAG_SUCCESS, response.data);
                        resolve(response);
                    }
                    else {
                        commit(ADMIN_DELETE_RESULTTAG_ERROR, response);
                        reject(response.error);
                    }
                })
                .catch((error) => {
                    commit(ADMIN_DELETE_RESULTTAG_ERROR, error);
                    reject(error);
                });
        });
    },
};

const mutations = {
    [GET_RESULT_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [GET_RESULT_SUCCESS]: (state, response) => {
        state.status = 'success';
        Vue.set(state, 'report', response.report);
        state.hasLoadedOnce = true;
    },
    [GET_RESULT_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [GET_REPORT_SURVEY_SUCCESS]: (state) => {
        state.status = 'loading';
    },
    [GET_REPORT_SURVEY_SUCCESS]: (state, response) => {
        state.status = 'success';
        Vue.set(state, 'reports', response.reports);
        state.hasLoadedOnce = true;
    },
    [GET_REPORT_SURVEY_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_RESULTSURVEY_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_RESULTSURVEY_SUCCESS]: (state, response) => {
        state.status = 'success';
        Vue.set(state, 'results', response.results);
        state.hasLoadedOnce = true;
    },
    [ADMIN_RESULTSURVEY_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_RESULTTAGS_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_RESULTTAGS_SUCCESS]: (state, response) => {
        state.status = 'success';
        Vue.set(state, 'tags', response.tags);
        state.hasLoadedOnce = true;
    },
    [ADMIN_RESULTTAGS_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_RESULTTAG_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_RESULTTAG_SUCCESS]: (state, response) => {
        state.status = 'success';
        Vue.set(state, 'tag', response.tag);
        state.hasLoadedOnce = true;
    },
    [ADMIN_RESULTTAG_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_ADD_RESULTTAG_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_ADD_RESULTTAG_SUCCESS]: (state, response) => {
        state.status = 'success'
        state.hasLoadedOnce = true;
    },
    [ADMIN_ADD_RESULTTAG_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_UPDATE_RESULTTAG_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_UPDATE_RESULTTAG_SUCCESS]: (state, response) => {
        state.status = 'success'
        state.hasLoadedOnce = true;
    },
    [ADMIN_UPDATE_RESULTTAG_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
    [ADMIN_DELETE_RESULTTAG_REQUEST]: (state) => {
        state.status = 'loading';
    },
    [ADMIN_DELETE_RESULTTAG_SUCCESS]: (state, response) => {
        state.status = 'success'
        state.hasLoadedOnce = true;
    },
    [ADMIN_DELETE_RESULTTAG_ERROR]: (state, response) => {
        state.status = 'error';
        state.hasLoadedOnce = true;
        Vue.set(state, 'errors', response.error);
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
};
